import { lazy } from "react";
import Loadable from "app/components/Loadable";

const ChangeRequestList = Loadable(lazy(() => import("./ChangeRequestList")));
const ChangeRequestForm = Loadable(lazy(() => import("./ChangeRequestForm")));

const ChangeRequestRoutes = [
  { path: "/itcms/it-change-request", element: <ChangeRequestList /> },
  {
    path: "/itcms/it-change-request/:mode/:id",
    element: <ChangeRequestForm />,
  },
];

export default ChangeRequestRoutes;
